var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"use-of-rejection-reason-report-page"},[_c('h1',{staticClass:"_page-title"},[_vm._v("Use of Rejection Reason Report")]),_c('div',{staticClass:"_page-content"},[_c('use-of-rejection-reason-report')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }